import React from 'react';
import styled from 'styled-components';
import { deprecated } from '@ally/metronome-icons';
import { Icon } from '../../Icon';
import { useSteppedProcess } from '../context';
const StepNumberWrapper = styled.div `
  ${({ isActive, isComplete, theme: { colors, font, space } }) => `
    height: 24px;
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${font.body.sm.size};
    line-height: ${font.body.sm.lineHeight};
    font-weight: bold;
    margin-right: ${space.sm};
    background: ${isActive || isComplete ? `${colors.plum}` : `${colors.white}`};
    color: ${isActive || isComplete ? `${colors.white}` : `${colors['gray-700']}`};
    border: 1px solid ${isActive || isComplete ? `${colors.plum}` : `${colors['gray-700']}`};
    border-radius: 50%;
  `}
`;
const StepNumber = ({ stepIndex }) => {
    const { isStepActive, stepState } = useSteppedProcess();
    const stepNumber = stepIndex + 1;
    const isActive = !!isStepActive(stepIndex);
    const isComplete = stepState(stepIndex) === 'complete';
    return (React.createElement(StepNumberWrapper, { isActive: isActive, isComplete: isComplete, "aria-hidden": true },
        React.createElement(React.Fragment, null, isComplete ? (React.createElement(Icon, { icon: deprecated.muiCheckMark, size: "xs", fill: "white", ariaHidden: true })) : (stepNumber))));
};
export { StepNumber };
//# sourceMappingURL=StepNumber.js.map